const defaultAgendasTransformer = response => {
  return response?.map(item => ({
    id: item?.id,
    title: item?.title,
    url: "",
    agendaType: "default",
  }))
}

export default defaultAgendasTransformer
